import axios from 'axios'
require('dotenv').config()

export default () => {
  let ax = axios.create({
    baseURL: process.env.VUE_APP_HOST,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  return ax
}
